<template>
  <div
    class="app-wrapper"
    :class="{
      'hide-sidebar': !sidebar.opened,
      'hide-content': sidebar.smallDevice && sidebar.opened
    }"
  >
    <sidebar
      class="sidebar-container"
      :is-menu-nav-active="isMenuNavActive"
      :expanded-sub-menu-index="expandedSubMenuIndex"
      :get-letter-for-index="getLetterForIndex"
    ></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>

    <el-backtop :right="16" :bottom="16" :visibility-height="200" />
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useMenuHotkeys } from '@/composables/hotkeys/useMenuHotkeys'

import { AppMain, Navbar, Sidebar } from './components'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const openSidebar = () => store.dispatch('openSideBar')
    const { isMenuNavActive, expandedSubMenuIndex, getLetterForIndex, deactivate } = useMenuHotkeys({
      router,
      openSidebar
    })

    return { isMenuNavActive, expandedSubMenuIndex, getLetterForIndex, deactivate }
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@use '/src/styles/mixin.scss';

.app-wrapper {
  @include mixin.clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
